import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

type HarlequinBackdropProps = {
  children?: ReactNode;
  variant?: 'default' | 'bright';
  className?: string;
};

/**
 * A purple diamond-pattern surface — echoes the cabinet topper.
 * Use behind hero sections or as a section divider.
 */
export function HarlequinBackdrop({
  children,
  variant = 'default',
  className,
}: HarlequinBackdropProps) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-2xl',
        variant === 'bright' ? 'bg-harlequin-bright' : 'bg-harlequin',
        className,
      )}
    >
      {/* Soft inner shadow to give depth */}
      <div className="pointer-events-none absolute inset-0 rounded-2xl shadow-[inset_0_0_60px_rgba(0,0,0,0.55)]" />
      <div className="relative">{children}</div>
    </div>
  );
}
